import { showSnackbar } from "utils/snack_bar/store/action";
import { actionTypes, CouponCreatedProps, CouponProps, CreateCouponInput, RedeemCouponInput, RedeemCouponProps } from "./actionType";
import { FETCH_COUPONS } from "../graphql/query";
import { GENERATE_COUPON, REDEEM_COUPON } from "../graphql/mutation";
import { MembershipPlansProps } from "modules/membership_plan/commercial_membership_plan/commercial_membership/store/actionType";
import { executeMutation, executeQuery } from "utils/services/apiServices";

// fetch membership duration
export const fetchCouponsRequest = () => ({
  type: actionTypes.FETCH_COUPONS_REQUEST,
});

export const fetchCouponsSuccess = (payload: CouponProps[]) => ({
  type: actionTypes.FETCH_COUPONS_SUCCESS,
  payload,
});

export const fetchCouponsFail = (payload: string) => ({
  type: actionTypes.FETCH_COUPONS_FAIL,
  payload,
});

export const fetchCoupons = () => {
  return async (dispatch: any) => {
    try {
      await dispatch(fetchCouponsRequest());
      const response = await executeQuery(FETCH_COUPONS);
      const jsonData = response.data?.FetchCoupons;
      if (jsonData?.error === null) {
        dispatch(fetchCouponsSuccess(jsonData?.data.coupons));
      } else {
        dispatch(fetchCouponsFail(jsonData?.error.message));
      }
    } catch (error: any) {
      dispatch(fetchCouponsFail("Failed to fetch coupon(s)"));
    }
  };
};

// create membership duration
export const createCouponRequest = () => ({
  type: actionTypes.CREATE_COUPON_REQUEST,
});

export const createCouponSuccess = (payload: CouponCreatedProps) => ({
  type: actionTypes.CREATE_COUPON_SUCCESS,
  payload,
});

export const createCouponFail = (payload: string) => ({
  type: actionTypes.CREATE_COUPON_FAIL,
  payload,
});

export const createCoupon = (createDataInput: CreateCouponInput) => {
  return async (dispatch: any) => {
    try {
      dispatch(createCouponRequest());
      const inputData = {
        input: createDataInput,
      };
      const response = await executeMutation(GENERATE_COUPON, inputData);
      const jsonData = response.data?.generateAndStoreCoupon;
      if (jsonData?.error === null) {
        dispatch(createCouponSuccess(jsonData));
        dispatch(showSnackbar("Success! Package created."));
      } else {
        dispatch(createCouponFail(jsonData?.error));
        dispatch(showSnackbar(`Error: ${(jsonData?.error) ? (jsonData?.error) : `"Fail to Generate Coupon."`}`));
      }
    } catch (error: any) {
      dispatch(createCouponFail("Something went wrong, Try again later"));
    }
  };
};
// create membership duration
export const redeemCouponRequest = () => ({
  type: actionTypes.REDEEM_COUPON_REQUEST,
});

export const redeemCouponSuccess = (payload: RedeemCouponProps) => ({
  type: actionTypes.REDEEM_COUPON_SUCCESS,
  payload,
});

export const redeemCouponFail = (payload: string) => ({
  type: actionTypes.REDEEM_COUPON_FAIL,
  payload,
});

export const redeemCoupon = (redeemInput: RedeemCouponInput) => {
  return async (dispatch: any) => {
    try {
      dispatch(redeemCouponRequest());
      const response = await executeMutation(REDEEM_COUPON, redeemInput);
      const jsonData = response.data?.redeemCoupon;
      if (jsonData?.error === null) {
        dispatch(redeemCouponSuccess(jsonData?.data.user_membership));
        dispatch(showSnackbar("Success! Package redeemd."));
      } else {
        dispatch(redeemCouponFail(jsonData?.error.message));
        dispatch(showSnackbar(`Error: ${(jsonData?.error.message) ? (jsonData?.error.message) : `"Fail to redeem Coupon."`}`));
      }
    } catch (error: any) {
      dispatch(redeemCouponFail("Something went wrong, Try again later"));
    }
  };
};

//RESET
export const ResetCoupon = () => ({
  type: actionTypes.RESET_COUPON,
});

export const resetCoupon = () => {
  return async (dispatch: any) => {
    dispatch(ResetCoupon());
  };
};
